<template>
	<div>
		<div class="index">
			<div class="m view">
				<div class="head">
					<img src="../../assets/images/index/user.png" />
					<span style="margin-right:10px;font-weight:550;">contract address:</span>
					<input id="biao1" :value="contract_address" readonly style="border:none;width:286px;"></input>
					<span class="but" :class="{'active':copyFlag}" @click="copy()">copy</span>
				</div>
				<div class="list_but flex_start">
					<div class="button" :class="{'active':active==0}" @click="active=0">
						Creation({{CreationNum}})
					</div>
					<div class="button" :class="{'active':active==1}" @click="active=1">
						Collection({{CollectionNum}})
					</div>
				</div>
				<div class="body" v-if="active==0">
					<el-empty :image-size="200" description="no results" v-if="goodsList==''||goodsList==null" style="width:100%;padding:50px;">
					</el-empty>
					<div class="li" :class="{'active':sun==index}" v-for="(item,index) in goodsList"
						@mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)" v-else @click="nav_shop(item)">
						<el-image style="width: 100%; height: 300px" :src="item.cover" fit="cover">
							<div slot="error" class="image-slot flex_all" style="height:100%;">
								<i class="el-icon-loading" style="font-size:30px;"></i>
							</div>
						</el-image>
						<div class="font">
							<p class="title">{{item.title}}</p>
							<div class="flex_between_x">
								<span>
									versions:{{item.serial}}/{{item.num}}
								</span>
								<div class="flex_start">
									<img src="../../assets/images/index/aixin.png"
										style="width:20px;height:20px;border-radius:50%;margin-right:5px;">
									{{item.fond_count}}
								</div>
							</div>
						</div>
						<div class="flex_start " style="padding:15px 10px 10px 10px;">
							<span>original</span>
							<div class="flex_start" style="margin-left:20px;">
								<el-image style="width: 30px; height: 30px ;border-radius:50%;margin-right:10px;"
									:src="item.o_avatar" fit="cover">
									<div slot="error" class="image-slot flex_all" style="height:100%;">
										<i class="el-icon-loading" style="font-size:20px;"></i>
									</div>
								</el-image>
								<span>{{item.o_nickname}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="body" v-else>
					<el-empty :image-size="200" description="no results" v-if="buysList==''||buysList==null" style="width:100%;padding:50px;">
					</el-empty>
					<div class="li" :class="{'active':sun==index}" v-for="(item,index) in buysList"
						@mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)" v-else @click="nav_shop(item)">
						<el-image style="width: 100%; height: 300px" :src="item.cover" fit="cover"></el-image>
						<div class="font">
							<p class="title">{{item.title}}</p>
							<div class="flex_between_x">
								<span>
									versions:{{item.serial}}/{{item.num}}
								</span>
								<div class="flex_start">
									<img src="../../assets/images/index/aixin.png"
										style="width:20px;height:20px;border-radius:50%;margin-right:5px;">
									{{item.fond_count}}
								</div>
							</div>
						</div>
						<div class="flex_start " style="padding:15px 10px 10px 10px;">
							<span>original</span>
							<div class="flex_start" style="margin-left:20px;">
								<el-image style="width: 30px; height: 30px ;border-radius:50%;margin-right:10px;"
									:src="item.o_avatar" fit="cover">
									<div slot="error" class="image-slot flex_all" style="height:100%;">
										<i class="el-icon-loading" style="font-size:20px;"></i>
									</div>
								</el-image>
								<span>{{item.o_nickname}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				sun: 0,
				goodsList: [],
				buysList: [],
				active: 0,
				contract_address: "",
				copyFlag: false,
				CollectionNum:0,
				CreationNum:0
			}
		},
		mounted() {
			this.contract_address = this.$route.query.contract_address
			this.getGoods(this.$route.query.contract_address)
			this.getBuys(this.$route.query.contract_address)
		},
		methods: {
			mouseOver(index) {
				this.sun = index
			},
			mouseLeave(index) {
				this.sun = -1
			},
			async getGoods(contract_address) {
				let res = await this.$api.getGoods({
					address: contract_address,
					page: 0,
					pagesize: 1000
				})
				if (res.code == 200) {
					console.log(res.data)
					this.goodsList = res.data
					this.CreationNum=res.totalCount
				}
			},
			async getBuys(contract_address) {
				let res = await this.$api.getBuys({
					address: contract_address,
					page: 0,
					pagesize: 1000
				})
				if (res.code == 200) {
					console.log(res.data)
					this.buysList = res.data
					this.CollectionNum=res.totalCount
				}
			},
			nav_shop(item) {
				this.$router.push({
					name: 'shop',
					query: {
						tid: item.tid
					}
				})
			},
			copy() {
				var Url2 = document.getElementById("biao1");
				Url2.select(); // 选择对象
				document.execCommand("Copy"); // 执行浏览器复制命令
				this.copyFlag = true
				this.$message({
					message: 'copied',
					type: 'success'
				});
			}

		}
	}
</script>

<style lang="scss" scoped>
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
	}

	.index {
		width: 100%;
		margin-top: 70px;
		padding-bottom: 100px;

		.view {
			padding: 100px 0px;

			.head {
				box-shadow: 0 1px 23px 0 #f2f2f2;
				height: 50px;
				line-height: 50px;
				border-radius: 8px;
				padding: 0px 30px;
				display: flex;
				align-items: center;
				font-size: 16px;

				img {
					width: 20px;
					height: 20px;
					margin-right: 10px;
				}

				.but {
					border: 1px solid #CCCCCC;
					height: 24px;
					font-size: 12px;
					padding: 0px 10px;
					border-radius: 5px;
					margin-left: 10px;
					cursor: pointer;
					display: flex;
					align-items: center;

					&.active {
						background-color: #67C23A;
						color: #FFFFFF;
					}
				}
			}

			.list_but {
				margin: 30px 0px;

				.button {
					height: 50px;
					line-height: 50px;
					width: 150px;
					border: 1px solid #CCCCCC;
					margin-right: 20px;
					border-radius: 5px;
					background-color: #FFFFFF;
					text-align: center;
					font-size: 18px;
					cursor: pointer;

					&.active {
						background-color: #333333;
						color: #FFFFFF;
						font-weight: 550;
					}
				}
			}

			.body {
				width: 100%;
				align-items: center;
				border-radius: 5px;
				display: flex;
				justify-content: flex-start;
				flex-wrap: wrap;
				cursor: pointer;

				.li {
					width: 220px;
					border: 1px solid #000000;
					border-radius: 6px;
					overflow: hidden;
					margin-right: 20px;
					margin-bottom: 20px;

					.font {
						border-bottom: 1px solid #CCCCCC;
						padding: 10px;
						text-align: left;

						.title {
							font-size: 14px;
							font-weight: 550;
							margin-bottom: 10px;
							text-align: left;
							display: inline-block;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}

					&.active {
						box-shadow: 0 1px 23px 0 #9a9a9a;
						border: none;
						width: 220px;
					}
				}
			}
		}
	}
</style>
